import React from 'react';
import Swal from 'sweetalert2';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup} from 'reactstrap';
import {Link, useNavigate} from "react-router-dom";
//import CONST from "../config/configFeria.json";

//Clase que sirve como nucleo del frontal.

//Se añade a las propiedades la funcion useNavigate para moverse entre las url de forma programática
const withRouter = WrappedComponent => props => {
  const navigate = useNavigate();

  return (
    <WrappedComponent
      {...props}
      navigate={navigate}
    />
  );
};


class Funciones extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        eliminado: false,
        abierto: false,
        duplicado: false,
        nuevoArchivo: '',
        publicUrl: ""
      };
      this.state.publicUrl = props.publicUrl;
      this.state.arch = props.arch;
      this.eliminar = this.eliminar.bind(this);
      this.manejarCambio = this.manejarCambio.bind(this);
      this.copiar = this.copiar.bind(this);
      this.generarUrlSincronizar = this.generarUrlSincronizar.bind(this);
      this.fairs = props.fairs;
      this.fairsData = props.fairsData;
    }

    //Funcion de eliminación
    async eliminar() {
      //Salta una alerta de sweetalert2 para preguntar si se desea eliminar el archivo
      const resultado = await Swal.fire({
        title: 'Confirmación',
        text: '¿Desea eliminar el siguiente archivo: '+this.props.arch+'?',
        showCancelButton: true,
        cancelButtonColor: '#f14668',
        confirmButtonColor: '#3298dc',
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: 'No',
        reverseButtons: true,
        
      });

      //En caso de que se cancele el borrado vuelve a la lista
      if (!resultado.value) {
        return;
      }

      //Si se confirma la eliminación se llama a la función de borrado del back
      /* const borrar = await fetch(process.env.REACT_APP_URL_ACTIONS+'eliminar.php?archivos='+this.props.arch,{
        method: "DELETE",
        
      }) */

      const fair = this.fairsData.find(item => item.fair === this.props.arch);
      const borrar = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/config-planner/${fair.id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "accept": "*/*"
        },
      })
      //En caso de que el borrado sea exitoso se pone el state eliminado a true
      const exitoso = await borrar;
      console.log(exitoso);
      if(exitoso) {
        this.setState({
          eliminado: true,
        });
      } else if (exitoso === false) {
        alert("Se ha producido un error en la eliminación del archivo.");
      } else if (exitoso === "ultimo") {
        alert("Este es el último fichero del listado, no puede ser eliminado");
      }
    
    
  }

  //Funcion que abre el modal
  abrirModal=()=>{
    this.setState({abierto: !this.state.abierto})
  }

  //Funcion de copia
  async copiar(event){
    const responseDataToDuplicate = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/config-planner/fair/${this.state.arch}`);
    const dataToDuplicate = await responseDataToDuplicate.json();
    //Se crea una constante que recogerá el nombre del archivo nuevo que has copiado y le elimina los espacios al principio y al final del string
    var archivoNuevo = (this.state.nuevoArchivo).trim();
    for (var i = 0; i < archivoNuevo.length; i++) {
      if(archivoNuevo.charAt(i) === " "){
        alert("El campo no puede tener espacios");
        return;
      }
    }
    //En caso de que el campo esté vacío se mostrará un mensaje de aviso
     if (archivoNuevo === ""){
      alert("El campo no puede estar vacío");
      return;
    }
    
    const isNameExists = this.fairs.some(item => item === archivoNuevo);

    //En caso de exito se redireccionará automaticamente a la pantalla de edición del nuevo archivo
    
    
    if (!isNameExists) {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/config-planner`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "accept": "*/*"
        },
        body: JSON.stringify({
            "fair": archivoNuevo,
            "config": dataToDuplicate.config
        })
      }).then(res => {
        this.props.navigate(`editar/${archivoNuevo}`);
      })

    } else if (isNameExists){
      
      //En caso negativo será porque ya existe un fichero con el mismo nombre en el directorio, se le avisa al usuario.
      alert("Ya existe un fichero con el mismo nombre, pruebe uno diferente.")
      return;
      
    }
  }

  //Funcion que maneja el cambio en el imput del formulario modal de duplicados.
  manejarCambio(event){
    this.setState({nuevoArchivo: event.target.value});
  }

  generarUrlSincronizar(){
    window.open("../cronjobs/async-requests.php?feria=" + this.props.arch.substring(0, this.props.arch.length - 4) + "&rand=" + Math.floor(Math.random() * 10000000000), '_blank');
  }

    render() {
      //Estilos del modal para que aparezca siempre en el centro de la pantalla
      const modalStyles={
        position: "absolute",
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }

      // var urlPlanificador = "../es/" + this.props.arch.substring(0, this.props.arch.length -4);
      var urlPlanificador = `${process.env.REACT_APP_URL_ACTIONS}/es/${this.props.arch}/islas`
      var longitudNombre = this.props.arch.length;
      var nombreArchivo = this.props.arch;
      //Si el state eliminado es true se elimina el archivo de la lista visible automáticamente
      if (this.state.eliminado) {
        return null;
      }
        return(
            <>
            <tr>
            <td>{nombreArchivo}</td>
            <td>
              <Link to={{pathname: `editar/${this.props.arch}` }} className="btn btn-success">Editar</Link>
              <button
                className="btn btn-success"
                onClick={() => {
                  this.eliminar();
                }} 
              >
                  Eliminar
              </button>        
              <button
                className="btn btn-success"
                onClick={() => {
                  this.abrirModal()
                }}
              >
                Copiar
              </button>
              <a href={urlPlanificador} target="_blank" rel="noreferrer" className="btn btn-success">Ver</a>
              {/* <button onClick={this.generarUrlSincronizar} className="sincronizar">Sincronizar</button> */}
            </td>
          </tr>
          
            <Modal isOpen={this.state.abierto} style={modalStyles}>
              <ModalHeader>
                Cambie el nombre de su archivo duplicado.
                <ModalBody>
                  <FormGroup>
                    <Label for="Archivo">Nuevo nombre:</Label>
                    <Input autoFocus={true} type="text" onChange={this.manejarCambio}  value={this.state.nuevoArchivo}/>
                  </FormGroup>
                </ModalBody>
                <ModalFooter>
                <Button onClick={(this.abrirModal)}>Cerrar</Button>
                <Button onClick={this.copiar}>
                  Confirmar
                </Button>
                </ModalFooter>
              </ModalHeader>
            </Modal>
            
            </>
                  

  
        );
    }

}
export default withRouter(Funciones);